import React, { useState, useEffect, useCallback } from 'react';
import { SERVER_URL } from '../../constants.js';
import AdultTabs from '../TabComponent/AdultTabs.js';
import SearchList from '../shared utils/SearchList.js';
import AdultCard   from '../shared utils/AdultCard.js';
import Scroll from '../shared utils/Scroll.js';
import AddAdult from '../AddsEdits/Adult/AddAdult.js';

function AdultSearch({ selectedYear, showFinancials, openAdultId, clearOpenAdultId }) {
  const [searchField, setSearchField] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [adults, setAdults] = useState([]);
  const [yearSelected] = useState([selectedYear]);

  const filteredPersons = adults.filter(
    (person) =>
      person.id.toString().includes(searchField.toLowerCase()) ||
      person.adultName?.toLowerCase().includes(searchField.toLowerCase()) ||
      person.adultSurname?.toLowerCase().includes(searchField.toLowerCase()) ||
      person.adultNationality?.toLowerCase().includes(searchField.toLowerCase())
  );
  
  const handleCardClick = (person) => {
    setSelectedPerson(person);
    setSearchShow(false);
  };

  useEffect(() => {
  
        console.log(">>> openAdultId changed to:", openAdultId);
    console.log(">>> adults array length:", adults.length);
    
    console.log(">>> adults[0]?.id, adults[0]?.adultId:", 
      adults[0]?.id, adults[0]?.adultId);
  
  
    
    if (openAdultId != null && adults.length > 0) {
      const match = adults.find(
        (s) => s.id === openAdultId || s.adultId === openAdultId
      );
      console.log(">>> find(s) result:", match);
      if (match) {
        handleSelectAdult(openAdultId);
      }
    }
  }, [openAdultId, adults]);

  const handleSelectAdult = (adultId) => {
   const adult = adults.find((s) => s.id === adultId);
    if (adult) {
      setSelectedPerson(adult);
      setSearchShow(false);
    }
  };

  const handleCloseTabs = () => {
    setSelectedPerson(null);
    setSearchField("");
    fetchData();
    setSearchShow(false);
    if (typeof clearOpenAdultId === 'function') {clearOpenAdultId()};
    //setRefreshTrigger(prev => prev + 1); // Increment to trigger a refresh
  };

  const fetchData = () => {
    console.log("triggered fetch data: " + yearSelected);
    fetchAdults();
    };

  const searchList = () => {
    // don’t show anything until at least 1 char entered
    if (!searchShow || searchField.trim().length < 1) return null;

    return (
      <Scroll>
        <SearchList
          filteredPersons={filteredPersons}
          handleCardClick={handleCardClick}
          maxCards={80}
          CardComponent={AdultCard}
        />
      </Scroll>
    );
  };

  
  const fetchAdults = useCallback(() => {
    setAdults([]);
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/adults`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return [];
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch adults');
        }
      })
      .then((data) => {
        sessionStorage.setItem('adults', JSON.stringify(data));
        setAdults(data);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    console.log("triggered fetch adults");
    fetchAdults();
  }, [fetchAdults]);

  const handleChange = (e) => {
    const val = e.target.value;
    setSearchField(val);
    setSearchShow(val.trim().length >= 1);
  };

  const handleReset = () => {
    setSearchField("");
    setSearchShow(false);
  };

  const showTabs = () => {
    if (selectedPerson !== null) {
      return <AdultTabs selectedPerson={selectedPerson} onClose={handleCloseTabs} showFinancials={showFinancials} />;
    }
    return null;
  };

  const addAdult = (adult) => {
    const token = sessionStorage.getItem("bearer");
    return fetch(`${SERVER_URL}api/adults`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(adult)
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        alert('Something went wrong!');
        return null;
      }
    })
    .then(newAdult => {
      if (newAdult) {
        fetchData();
        //setRefreshTrigger(prev => prev + 1); // Increment to trigger a refresh
        return newAdult.id;
      }
    })
    .catch(err => {
      console.error(err);
      return null; // Ensure the function always returns something
    });
  };

  return (
    <section className="garamond">
      <form onReset={handleReset}>
        <div className="pa2">
          <input
            className="pa3 bb br3 grow b--none bg-lightest-blue ma3"
            type="search"
            placeholder="Search by Name, Nationality, or ID..."
            style={{ width: "50%" }}
            value={searchField}
            onChange={handleChange}
          />
        </div>
        {searchList()}
        {showTabs()}
        <div>
          <AddAdult addAdult={addAdult}/>
          <p style={{ color: '#999999', fontSize: '10px' }}>
            Is authenticated: {sessionStorage.getItem('isAuthenticated').toString()}
          </p>
        </div>
       </form>
    </section>
  );
}

export default AdultSearch;
